"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOptions = exports.mapDataWithGaugeDetails = void 0;
var utils_1 = require("../utils");
var highcharts_1 = __importDefault(require("highcharts"));
var solid_gauge_1 = __importDefault(require("highcharts/modules/solid-gauge"));
var highcharts_more_1 = __importDefault(require("highcharts/highcharts-more"));
var design_system_colors_1 = require("../../../../style/theme/design-system-colors");
var style_1 = require("../../../../style");
var constants_1 = require("./constants");
var lodash_1 = require("lodash");
highcharts_more_1.default(highcharts_1.default);
solid_gauge_1.default(highcharts_1.default);
var getGaugeRadius = function (index) {
    var innerRadius = constants_1.INNERMOST_GAUGE_RADIUS + (index * 12);
    var outerRadius = innerRadius + 10;
    return { innerRadius: innerRadius, outerRadius: outerRadius };
};
var mapDataWithGaugeDetails = function (data) {
    return data.map(function (item, index) {
        var _a = getGaugeRadius(index), innerRadius = _a.innerRadius, outerRadius = _a.outerRadius;
        return __assign(__assign({}, item), { data: [
                __assign(__assign({}, (lodash_1.get(item, 'data[0]', {}))), { color: constants_1.ACTIVITY_GUAGE_CHART_COLORS[index], radius: outerRadius + "%", innerRadius: innerRadius + "%" }),
            ] });
    });
};
exports.mapDataWithGaugeDetails = mapDataWithGaugeDetails;
var computePaneBackground = function (data) { return data.map(function (_, index) {
    var _a = getGaugeRadius(index), innerRadius = _a.innerRadius, outerRadius = _a.outerRadius;
    return ({
        outerRadius: outerRadius + "%",
        innerRadius: innerRadius + "%",
        borderWidth: 0,
    });
}); };
var getOptions = function (data, size, guageCentreTitle, gaugeTotalValue, legendAlignment, toolTipFormatter, legendItemFormatter, gaugeCentreFormatter) { return ({
    series: data,
    total: gaugeTotalValue,
    chart: {
        type: 'solidgauge',
        height: size,
    },
    pane: {
        background: computePaneBackground(data),
    },
    yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
    },
    plotOptions: {
        solidgauge: {
            showInLegend: true,
            dataLabels: {
                useHTML: true,
                borderWidth: 0,
                y: -25,
                formatter: function () {
                    return gaugeCentreFormatter(guageCentreTitle, lodash_1.get(this, 'series.chart.userOptions.total'));
                },
            },
            linecap: 'round',
            rounded: true,
        },
    },
    tooltip: __assign(__assign({}, utils_1.tooltipOptions), { followPointer: true, borderRadius: 10, useHTML: true, formatter: function () {
            var _this = this;
            var dataItem = lodash_1.find(data, function (item) { return lodash_1.get(item, 'name') === _this.series.name; });
            return toolTipFormatter(this.color, this.series.name, this.y, lodash_1.get(dataItem, 'tooltipBadgeContent'));
        } }),
    legend: __assign(__assign({}, (legendAlignment === constants_1.LEGEND_ALIGNMENT.horizontal ?
        {
            align: 'center',
            layout: 'horizontal',
            verticalAlign: 'bottom',
        } : {
        align: 'right',
        layout: 'vertical',
        verticalAlign: 'top',
    })), { itemMarginTop: 10, symbolHeight: 0, symbolWidth: 0, squareSymbol: false, useHTML: true, labelFormatter: function () {
            return legendItemFormatter(lodash_1.get(this, 'userOptions.data[0].color', design_system_colors_1.DesignSystemColor.Gray.DEFAULT), lodash_1.get(this, 'name'));
        }, itemStyle: {
            color: design_system_colors_1.DesignSystemColor.Gray.DEFAULT,
            fontSize: style_1.pxToRem(14),
            fontWeight: '400',
        } }),
}); };
exports.getOptions = getOptions;
